import { Unit } from "@/helpers/Unit";
import { RechargeAddress } from "../portal";
import { ShopifyAddress } from "./types";

type FrequencyUnit = {
  frequency: number;
  unit: Unit;
};

export function parseDeliveryFrequency(input: string): FrequencyUnit {
  // Define regex patterns for different units
  const regex = /Delivery every (\d+) (days?|weeks?|months?)/i;

  // Match the input string against the regex
  const match = input.match(regex);
  const defaultCadnce = {
    frequency: 4,
    unit: new Unit("month"),
  };
  if (match) {
    const frequency = parseInt(match[1], 10);
    let unit: "day" | "week" | "month";

    // Determine the correct unit
    switch (match[2].toLowerCase()) {
      case "day":
      case "days":
        unit = "day";
        break;
      case "week":
      case "weeks":
        unit = "week";
        break;
      case "month":
      case "months":
        unit = "month";
        break;
      default:
        return defaultCadnce; // Unit is not recognized
    }

    return { frequency, unit: new Unit(unit) };
  }

  return defaultCadnce; // Input string does not match the expected format
}

export function matchedRechargeAddress(
  rechargeAddresses: RechargeAddress[],
  shopifyAddress: ShopifyAddress
): RechargeAddress | undefined {
  // Filter out deleted addresses
  const availableAddresses = rechargeAddresses.filter(
    (address) => address.deleted_at === null
  );

  // Function to compare two addresses
  const compareAddresses = (
    rechargeAddr: RechargeAddress,
    shopifyAddr: ShopifyAddress
  ): boolean => {
    const trimAndLower = (str?: string) => str?.trim().toLowerCase() || "";

    return (
      trimAndLower(rechargeAddr.address1) ===
        trimAndLower(shopifyAddr.address1) &&
      trimAndLower(rechargeAddr.address2) ===
        trimAndLower(shopifyAddr.address2) &&
      trimAndLower(rechargeAddr.city) === trimAndLower(shopifyAddr.city) &&
      trimAndLower(rechargeAddr.zip) === trimAndLower(shopifyAddr.zip) &&
      trimAndLower(rechargeAddr.province) ===
        trimAndLower(shopifyAddr.province) &&
      trimAndLower(rechargeAddr.company) ===
        trimAndLower(shopifyAddr.company) &&
      trimAndLower(rechargeAddr.country) === trimAndLower(shopifyAddr.country)
    );
  };

  // Find the matching address
  return availableAddresses.find((address) =>
    compareAddresses(address, shopifyAddress)
  );
}
